import { render, staticRenderFns } from "./Roster.vue?vue&type=template&id=5016f248&scoped=true"
import script from "./Roster.vue?vue&type=script&lang=js"
export * from "./Roster.vue?vue&type=script&lang=js"
import style0 from "./Roster.vue?vue&type=style&index=0&id=5016f248&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5016f248",
  null
  
)

export default component.exports